import header from '../_modules/header/index.js';
import { initializeCrisp, revealLinksOnAction, setTimezone } from '../_modules/helpers';
import initTestimonials from './js/testimonials.js';
import workerHandler from "./js/workerHandler.js";
import { initSlider } from './js/slider.js';
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';

if (document.readyState === 'interactive') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
}

function init() {
    workerHandler.init();
    header();
    initTestimonials();
    initializeCrisp();
    revealLinksOnAction(() => {
        handleRefsUs(REFS_US.SEO_US_INFO)
        FirstTouchTracking()
    });
    initSlider('.team-slider');
    setTimezone();
}
